import { DadosDepreciacao } from '@/features/laudo/types/laudo-wizard.types';
import { AMOSTRAS_PADRONIZADAS } from './amostrasPadronizadas';

export const dadosDepreciacaoMock: DadosDepreciacao[] = AMOSTRAS_PADRONIZADAS.map(amostra => ({
  identificacao: amostra.identificacao,
  tipoImovel: amostra.tipoImovel,
  idadeAparente: Number(amostra.idadeAparente) || 0,
  estadoConservacao: amostra.estadoConservacao,
  vidaUtil: amostra.tipoImovel === 'Apartamento' ? 60 : 70,
  valorResidual: 0.2,
  coefHeidecke: 0,
  porcentagemVU: 0,
  depreciacao: 0,
}));
